import { factoryYup, limit } from 'app/core/factory-yup';

import { EmailRequired, ObjectRequired, StringRequired } from '../../../../core/validations/common';

import { type TaxpayerFieldValidationRule } from './index';
const yup = factoryYup();

export const rulesTaxData: Array<TaxpayerFieldValidationRule> = [
  {
    validation: {
      contactName: StringRequired.max(limit.maxName),
      email: EmailRequired.max(limit.maxEmail),
      taxReturnCurrency: ObjectRequired,
      contactTaxIdNumber: yup.string().nullable().max(limit.maxCode)
    }
  },
  {
    field: 'taxIdentificationNumber',
    validation: { idTax: StringRequired.max(limit.maxCode) }
  },
  {
    field: 'taxContactIdentificationNumber',
    validation: { idDocNumber: StringRequired.max(limit.maxCode) }
  },
  {
    field: 'phoneNumber',
    validation: {
      phoneNumberArea: StringRequired.max(limit.maxPhoneNumberArea),
      phoneNumber: StringRequired.max(limit.maxCode)
    }
  }
];
